/** Frontend-API für Signal-Quellen (compass-new, Migration 116). */

export type SignalSourceType = 'applai' | 'email' | 'http' | 'rss' | 'webhook' | 'join';

export interface SignalSource {
  id: number;
  type: SignalSourceType;
  name: string;
  enabled: boolean;
  intervalMs: number;
  config: Record<string, unknown>;
  lastRunAt: string | null;
  lastStatus: Record<string, unknown> | null;
}

export interface CreateSignalSourceInput {
  type: SignalSourceType;
  name: string;
  enabled?: boolean;
  intervalMs?: number;
  config?: Record<string, unknown>;
}

const URL = '/api/signal-sources';

async function req<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, init);
  if (!res.ok) {
    const b = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(b.error?.message ?? b.error ?? `Request failed: ${res.status}`);
  }
  return res.json() as Promise<T>;
}

const json = (method: string, body: unknown): RequestInit => ({ method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });

export async function listSources(): Promise<SignalSource[]> {
  const r = await req<{ sources: SignalSource[] }>(URL);
  return r.sources;
}

export async function createSource(input: CreateSignalSourceInput): Promise<SignalSource> {
  return req<SignalSource>(URL, json('POST', input));
}

export async function updateSource(id: number, fields: Partial<CreateSignalSourceInput>): Promise<SignalSource> {
  return req<SignalSource>(`${URL}/${id}`, json('PUT', fields));
}

export async function deleteSource(id: number): Promise<void> {
  await req(`${URL}/${id}`, { method: 'DELETE' });
}

export async function runSource(id: number): Promise<{ status: Record<string, unknown>; source: SignalSource }> {
  return req<{ status: Record<string, unknown>; source: SignalSource }>(`${URL}/${id}/run`, { method: 'POST' });
}
